/* eslint-disable sonarjs/no-duplicate-string */

'use strict';

var addressHelpers = require('./address');
var formHelpers = require('./formErrors');
var scrollAnimate = require('base/components/scrollAnimate');
var utils = require('../utils');
var accessPointHelper = require('./accessPoint');
var bossHelper = require('./boss');
var cvsHelper = require('./convenienceStore');
var yamatoHelper = require('./yamato');
var clientSideValidation = require('../components/clientSideValidation');

/**
 * Validates the shipping field on blur out event.
 * @returns {void}
 */
function validateShippingBlur() {
    $('#shippingState #OTHER').addClass('d-none');
    var textInputFields = '.shipping-form input, .shipping-form select';
    $('body').on('blur', textInputFields, function (event) {
        clientSideValidation.functions.handleOnBlur.apply(this, [event]);
    });
}
/**
 * toggle payment options view if order payment covered
 * @param {Object} data response object
 */
function checkOrderTotalCovered(data) {
    var $orderTotalSummary = $('.order-total-summary');
    if ($orderTotalSummary.length) {
        var $manualAfterpayWidget = $orderTotalSummary.find('.manual-afterpay-widget');
        var $afterpayOs = $orderTotalSummary.find('.afterpayos');
        if (data && (data.isOrderTotalGMPCovered || data.isOrderFree)) {
            $manualAfterpayWidget.addClass('d-none');
            $afterpayOs.addClass('d-none');
        } else {
            $manualAfterpayWidget.removeClass('d-none');
            $afterpayOs.removeClass('d-none');
        }
    }
}
/**
 * toggle gmp order summary view
 * @param {Object} data response object
 */
function toggleGmpOrderSummary(data) {
    var $gmpOrderSummary = $('.gmp-ordersummary');
    if ($gmpOrderSummary.length) {
        var $gmpUsed = $gmpOrderSummary.find('.gmp-used');
        if (data && data.gmpUsed) {
            $gmpOrderSummary.removeClass('d-none');
            $gmpUsed.text(data.gmpUsed);
        } else if (data && data.isClutchCustomerExists && data.isClutchCustomerBalanceExists) {
            $gmpOrderSummary.removeClass('d-none');
        } else {
            $gmpOrderSummary.addClass('d-none');
        }
    }
}
/**
 * updates the shipping address selector within shipping forms
 * @param {Object} productLineItem - the productLineItem model
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order model
 * @param {Object} customer - the customer model
 */
function updateShippingAddressSelector(productLineItem, shipping, order, customer) {
    var uuidEl = $('input[value=' + productLineItem.UUID + ']');
    var form;
    var $shippingAddressSelector;
    var hasSelectedAddress = false;
    if (uuidEl && uuidEl.length > 0) {
        form = uuidEl[0].form;
        $shippingAddressSelector = $('.addressSelector', form);
    }
    if ($shippingAddressSelector && $shippingAddressSelector.length === 1) {
        $shippingAddressSelector.empty();
        // Add New Address option
        $shippingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
            null,
            false,
            order
        ));
        if (customer.addresses && customer.addresses.length > 0) {
            $shippingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
                order.resources.accountAddresses,
                false,
                order
            ));
            customer.addresses.forEach(function (address) {
                var isSelected = shipping.matchingAddressId === address.ID;
                $shippingAddressSelector.append(
                    addressHelpers.methods.optionValueForAddress(
                        { UUID: 'ab_' + address.ID, shippingAddress: address },
                        isSelected,
                        order
                    )
                );
            });
        }
    }
    if (!hasSelectedAddress) {
        // show
        $(form).addClass('hide-details');
    } else {
        $(form).removeClass('hide-details');
    }
    $('body').trigger('shipping:updateShippingAddressSelector', {
        productLineItem: productLineItem,
        shipping: shipping,
        order: order,
        customer: customer
    });
}
/**
 * updates the shipping address form values within shipping forms
 * @param {Object} shipping - the shipping (shipment model) model
 */
function updateShippingAddressFormValues(shipping) {
    var isFromAltShipping = $('.js-from-alt-shipping').length;
    var addressObject = $.extend({}, shipping.shippingAddress);
    if (!addressObject) {
        addressObject = {
            firstName: null,
            lastName: null,
            firstNamePhonetic: null,
            lastNamePhonetic: null,
            address1: null,
            address2: null,
            address3: null,
            city: null,
            postalCode: null,
            stateCode: null,
            countryCode: null,
            phone: null
        };
    }
    addressObject.isGift = shipping.isGift;
    addressObject.giftMessage = shipping.giftMessage;
    addressObject.isGiftWrap = shipping.isGiftWrap;
    addressObject.giftWrapText = shipping.giftWrapText;

    $('input[value=' + shipping.UUID + ']').each(function (formIndex, el) {
        var form = el.form;
        if (!form) return;
        var countryCode = addressObject.countryCode;
        $('input[name$=_firstName]', form).val(addressObject.firstName);
        $('input[name$=_lastName]', form).val(addressObject.lastName);

        if (addressObject.firstNamePhonetic) {
            $('input[name$=_firstNamePhonetic]', form).val(addressObject.firstNamePhonetic);
        }

        if (addressObject.lastNamePhonetic) {
            $('input[name$=_lastNamePhonetic]', form).val(addressObject.lastNamePhonetic);
        }

        if (!isFromAltShipping) {
            $('input[name$=_address1]', form).val(addressObject.address1);
            $('input[name$=_address2]', form).val(addressObject.address2);
            $('input[name$=_address3]', form).val(addressObject.address3);
            $('select[name$=_city],input[name$=_city]', form).val(addressObject.city);
            $('input[name$=_postalCode]', form).val(addressObject.postalCode);
            $('select[name$=_stateCode],input[name$=_stateCode]', form)
                .val(addressObject.stateCode);
        }
        if (countryCode && typeof countryCode === 'object') {
            $('select[name$=_country]', form).val(addressObject.countryCode.value);
        } else if (countryCode && typeof countryCode !== 'object') {
            $('select[name$=_country]', form).val(addressObject.countryCode);
        }
        $('input[name$=_phone]', form).val(addressObject.phone);
        $('input[name$=_isGift]', form).prop('checked', addressObject.isGift);
        $('textarea[name$=_giftMessage]', form).val(
            addressObject.isGift
            && addressObject.giftMessage
                ? addressObject.giftMessage
                : ''
        );

        $('input[name$=_isGiftWrap]', form).prop('checked', addressObject.isGiftWrap);
        $('select[name$=_giftWrapText]', form).val(
            addressObject.isGiftWrap
            && addressObject.giftWrapText
                ? addressObject.giftWrapText
                : ''
        );
    });
    $('body').trigger('shipping:updateShippingAddressFormValues', { shipping: shipping });
}
/**
 * updates the shipping method radio buttons within shipping forms
 * @param {Object} shipping - the shipping (shipment model) model
 */
function updateShippingMethods(shipping) {
    var uuidEl = $('input[value=' + shipping.UUID + ']');
    if (uuidEl && uuidEl.length > 0) {
        $.each(uuidEl, function (shipmentIndex, el) {
            var form = el.form;
            if (!form) return;
            var $shippingMethodList = $('.shipping-method-list', form);
            if ($shippingMethodList && $shippingMethodList.length > 0) {
                $shippingMethodList.empty();
                var shippingMethods = shipping.applicableShippingMethods;
                if (shippingMethods && shippingMethods.length === 0) {
                    $(this).closest('form').find('.shipping-restriction-alert').removeClass('d-none');
                    $('button.submit-shipping').attr('disabled', true); //
                } else {
                    $(this).closest('form').find('.shipping-restriction-alert').addClass('d-none');
                    $('button.submit-shipping').removeAttr('disabled');
                }
                var selected = shipping.selectedShippingMethod || {};
                var shippingMethodFormID = form.name + '_shippingAddress_shippingMethodID';
                //
                // Create the new rows for each shipping method
                //
                $.each(shippingMethods, function (methodIndex, shippingMethod) {
                    var tmpl = $('#shipping-method-template').clone();
                    var input = $('input', tmpl);
                    // set input
                    input
                        .prop('id', 'shippingMethod-' + shippingMethod.ID + '-' + shipping.UUID)
                        .prop('name', shippingMethodFormID)
                        .prop('value', shippingMethod.ID)
                        .attr('checked', shippingMethod.ID === selected.ID);
                    if (window.sitePrefs.bopisEnabled) {
                        input.attr('data-pickup', shippingMethod.storePickupEnabled);
                    }
                    // Accesspoint and Boss are not enabled together.
                    if (window.sitePrefs.accessPoint && shippingMethod.accessPoint !== '') {
                        if (shippingMethod.bossEnabled === 'boss') {
                            input.attr('data-shippingtype', shippingMethod.bossEnabled);
                        } else {
                            input.attr('data-shippingtype', shippingMethod.accessPoint);
                        }
                    }
                    // Do nothing unless boss enabled
                    if (window.sitePrefs.bossEnabled && shippingMethod.bossEnabled !== '') {
                        if (shippingMethod.accessPoint === 'access-point') {
                            input.attr('data-shippingtype', shippingMethod.accessPoint);
                        } else {
                            input.attr('data-shippingtype', shippingMethod.bossEnabled);
                        }
                    }
                    if (window.sitePrefs.cvsPickupEnabled) {
                        if (shippingMethod.isConvenienceStore) {
                            input.attr('data-shippingtype', 'cvs');
                        } else {
                            input.attr('data-shippingtype', 'regular');
                        }
                    }
                    if (window.sitePrefs.yamatoPickupEnabled) {
                        if (shippingMethod.isYamatoPickup) {
                            input.attr('data-shippingtype', 'yamato');
                        } else {
                            input.attr('data-shippingtype', 'regular');
                        }
                    }
                    $('label', tmpl)
                        .prop('for', 'shippingMethod-' + shippingMethod.ID + '-' + shipping.UUID);
                    if (shippingMethod.isConvenienceStore && shippingMethod.shippingLogo !== null) {
                        var shippingLogo = '<img class="shippingMethod-logo" src="'
                            + shippingMethod.shippingLogo
                            + '" alt="'
                            + shippingMethod.displayName
                            + '" />';
                        $('label', tmpl).html(shippingLogo);
                    } else {
                        // set shipping method name
                        $('.display-name', tmpl).text(shippingMethod.displayName);
                        // set or hide arrival time
                        if (shippingMethod.estimatedArrivalTime) {
                            $('.arrival-time', tmpl)
                                .text(shippingMethod.estimatedArrivalTime)
                                .attr('data-testid', 'shipping-estimate-' + shippingMethod.ID)
                                .show();
                            $('label', tmpl).removeClass('py-3').addClass('py-2');
                        }
                    }
                    // set shipping cost
                    $('.shipping-cost', tmpl).text(utils.getAmountToDisplay(shippingMethod.shippingCost));
                    $shippingMethodList.append(tmpl.html());
                    if (window.sitePrefs.accessPoint) {
                        accessPointHelper.methods.displayShippingMethod();
                    }
                    if (window.sitePrefs.bossEnabled) {
                        bossHelper.methods.displayShippingMethod();
                    }
                    if (window.sitePrefs.cvsPickupEnabled) {
                        cvsHelper.methods.displayShippingMethod();
                    }
                    if (window.sitePrefs.yamatoPickupEnabled) {
                        yamatoHelper.methods.displayShippingMethod();
                    }
                });
            }
        });
    }
    $('body').trigger('shipping:updateShippingMethods', { shipping: shipping });
}
/**
 * Update list of available shipping methods whenever user modifies shipping address details.
 * @param {jQuery} $shippingForm - current shipping form
 * @param {boolean} payPalFromCart - update is trigged after landing on checkout from paypal cart checkout
 */
function updateShippingMethodList($shippingForm, payPalFromCart) {
    if (!$shippingForm.length) {
        return;
    }
    // delay for autocomplete
    setTimeout(function () {
        var $shippingMethodList = $shippingForm.find('.shipping-method-list');
        var urlParams = addressHelpers.methods.getAddressFieldsFromUI($shippingForm);
        var shipmentUUID = $shippingForm.find('[name=shipmentUUID]').val();
        var url = $shippingMethodList.data('actionUrl');
        urlParams.shipmentUUID = shipmentUUID;
        // if the countryCode isn't set in getAddressFieldsFromUI, grab it from the dom
        urlParams.countryCode = urlParams.countryCode || $('input[name$=_country]', $shippingForm).val();
        var $summaryElement = payPalFromCart ? $('.shipping-summary') : null;
        var accessPointID = $('.shipping-content').hasClass('shipping-type-access-point');
        urlParams.accessPointID = accessPointID;
        var bossStoreID = $('.shipping-content').hasClass('shipping-type-boss');
        urlParams.bossStoreID = bossStoreID;
        var cvsStore = $('.shipping-content').hasClass('shipping-type-cvs');
        urlParams.cvsStore = cvsStore;
        var yamatoStoreID = $('.shipping-content').hasClass('shipping-type-yamato');
        urlParams.yamatoStoreID = yamatoStoreID;
        var veiledElement = $summaryElement || $shippingMethodList;
        veiledElement.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    $('body').trigger('checkout:updateCheckoutView',
                        {
                            order: data.order,
                            customer: data.customer,
                            options: { keepOpen: true }
                        });
                    var updatedDeliveryEstimates = data.updatedDeliveryEstimates;
                    Object.keys(updatedDeliveryEstimates).forEach(function (estimate) {
                        $(
                            '.custom-product-card[data-uuid='
                            + estimate
                            + '] .estimate-msg'
                        ).text(updatedDeliveryEstimates[estimate]);
                    });
                    if (payPalFromCart) {
                        $('button.place-order').removeAttr('disabled');
                    }
                    if (window.sitePrefs.accessPoint) {
                        accessPointHelper.methods.displayShippingMethod();
                    }
                    if (window.sitePrefs.bossEnabled) {
                        bossHelper.methods.displayShippingMethod();
                    }
                    if (window.sitePrefs.cvsPickupEnabled) {
                        cvsHelper.methods.displayShippingMethod();
                    }
                    if (window.sitePrefs.cvsPickupEnabled) {
                        cvsHelper.methods.displayShippingMethod();
                    }
                    if (window.sitePrefs.yamatoPickupEnabled) {
                        yamatoHelper.methods.displayShippingMethod();
                    }
                }
            }
        }).always(function () {
            veiledElement.spinner().stop();
        });
    }, payPalFromCart ? 0 : 300);
}
/**
 * updates the order shipping summary for an order shipment model
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order model
 */
function updateShippingSummaryInformation(shipping, order) {
    $('[data-shipment-summary=' + shipping.UUID + ']').each(function (i, el) {
        var $container = $(el);
        var $shippingAddressLabel = $container.find('.shipping-addr-label');
        var $addressContainer = $container.find('.address-summary');
        var $shippingPhone = $container.find('.shipping-phone');
        var $methodTitle = $container.find('.shipping-method-title');
        var $methodArrivalTime = $container.find('.shipping-method-arrival-time');
        var $methodPrice = $container.find('.shipping-method-price');
        var $shippingSummaryLabel = $container.find('.shipping-method-label');
        var $summaryDetails = $container.find('.row.summary-details');
        var giftMessageSummary = $container.find('.gift-summary');
        var giftWrapSummary = $container.find('.gift-wrap-summary');
        var $orderEmail = $container.find('.email');
        var address = shipping.shippingAddress;
        var selectedShippingMethod = shipping.selectedShippingMethod;
        var isGift = shipping.isGift;
        var isGiftWrap = shipping.isGiftWrap;
        addressHelpers.methods.populateAddressSummary($addressContainer, address);
        if (address && address.phone) {
            if (address.phoneCode) {
                $shippingPhone.text(address.phoneCode + ' ' + address.phone);
            } else {
                $shippingPhone.text(address.phone);
            }
        } else {
            $shippingPhone.empty();
        }
        if (order && order.orderEmail) {
            $orderEmail.text(order.orderEmail);
        }
        if (selectedShippingMethod) {
            $('body').trigger('shipping:updateAddressLabelText',
                {
                    selectedShippingMethod: selectedShippingMethod,
                    resources: order.resources,
                    shippingAddressLabel: $shippingAddressLabel
                });
            $shippingSummaryLabel.show();
            $summaryDetails.show();
            $methodTitle.text(selectedShippingMethod.displayName);
            if (selectedShippingMethod.estimatedArrivalTime) {
                $methodArrivalTime.text(selectedShippingMethod.estimatedArrivalTime);
            } else {
                $methodArrivalTime.empty();
            }
            $methodPrice.text(selectedShippingMethod.shippingCost);
        }
        if (isGift) {
            giftMessageSummary.find('.gift-message-summary').text(shipping.giftMessage);
            giftMessageSummary.removeClass('d-none');
        } else {
            giftMessageSummary.addClass('d-none');
        }

        if (isGiftWrap) {
            giftWrapSummary.find('.gift-wrap-message-summary').text(shipping.giftWrapText);
            giftWrapSummary.removeClass('d-none');
        } else {
            giftWrapSummary.addClass('d-none');
        }
    });
    $('body').trigger('shipping:updateShippingSummaryInformation', { shipping: shipping, order: order });
}
/**
 * Update the read-only portion of the shipment display (per PLI)
 * @param {Object} productLineItem - the productLineItem model
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order model
 * @param {Object} [options] - options for updating PLI summary info
 * @param {Object} [options.keepOpen] - if true, prevent changing PLI view mode to 'view'
 */
function updatePLIShippingSummaryInformation(productLineItem, shipping, order, options) {
    var $pli = $('input[value=' + productLineItem.UUID + ']');
    var form = $pli && $pli.length > 0 ? $pli[0].form : null;
    if (shipping.selectedShippingMethod && shipping.selectedShippingMethod.description) {
        $(
            '.custom-product-card[data-uuid='
            + productLineItem.UUID
            + '] .estimate-msg'
        ).text(shipping.selectedShippingMethod.description);
    }
    if (!form) return;
    var $viewBlock = $('.view-address-block', form);
    var checkoutUtils = require('./utils');
    var addressObj = checkoutUtils.createAddressObj(shipping);
    var address = addressObj.address;
    var tmpl = addressObj.tmpl;
    checkoutUtils.fillShippingSummary(shipping, address, tmpl);
    if (shipping.isGift) {
        $('.gift-message-summary', tmpl).text(shipping.giftMessage);
        var shipment = $('.gift-message-' + shipping.UUID);
        $(shipment).val(shipping.giftMessage);
    } else {
        $('.gift-summary', tmpl).addClass('d-none');
    }

    if (shipping.isGiftWrap) {
        $('.gift-wrap-message-summary', tmpl).text(shipping.giftWrapText);
        var giftWrapShipment = $('.gift-wrap-message-' + shipping.UUID);
        $(giftWrapShipment).val(shipping.giftWrapText);
    } else {
        $('.gift-wrap-summary', tmpl).addClass('d-none');
    }

    // checking h5 title shipping to or pickup
    var $shippingAddressLabel = $('.shipping-header-text', tmpl);
    $('body').trigger('shipping:updateAddressLabelText',
        {
            selectedShippingMethod: shipping.selectedShippingMethod,
            resources: order.resources,
            shippingAddressLabel: $shippingAddressLabel
        });
    $viewBlock.html(tmpl.html());
    $('body').trigger('shipping:updatePLIShippingSummaryInformation', {
        productLineItem: productLineItem,
        shipping: shipping,
        order: order,
        options: options
    });
}
/**
 * Update the hidden form values that associate shipping info with product line items
 * @param {Object} productLineItem - the productLineItem model
 * @param {Object} shipping - the shipping (shipment model) model
 */
function updateProductLineItemShipmentUUIDs(productLineItem, shipping) {
    $('input[value=' + productLineItem.UUID + ']').each(function (key, pli) {
        var form = pli.form;
        $('[name=shipmentUUID]', form).val(shipping.UUID);
        $('[name=originalShipmentUUID]', form).val(shipping.UUID);
        $(form).closest('.card').attr('data-shipment-uuid', shipping.UUID);
    });
    $('body').trigger('shipping:updateProductLineItemShipmentUUIDs', {
        productLineItem: productLineItem,
        shipping: shipping
    });
}
/**
 * Update the shipping UI for a single shipping info (shipment model)
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order/basket model
 * @param {Object} customer - the customer model
 * @param {Object} [options] - options for updating PLI summary info
 * @param {Object} [options.keepOpen] - if true, prevent changing PLI view mode to 'view'
 */
function updateShippingInformation(shipping, order, customer, options) {
    // First copy over shipmentUUIDs from response, to each PLI form
    order.shipping.forEach(function (aShipping) {
        aShipping.productLineItems.items.forEach(function (productLineItem) {
            updateProductLineItemShipmentUUIDs(productLineItem, aShipping);
        });
    });
    // Now update shipping information, based on those associations
    updateShippingMethods(shipping);
    updateShippingAddressFormValues(shipping);
    updateShippingSummaryInformation(shipping, order);
    // And update the PLI-based summary information as well
    shipping.productLineItems.items.forEach(function (productLineItem) {
        updateShippingAddressSelector(productLineItem, shipping, order, customer);
        updatePLIShippingSummaryInformation(productLineItem, shipping, order, options);
    });
    $('body').trigger('shipping:updateShippingInformation', {
        order: order,
        shipping: shipping,
        customer: customer,
        options: options
    });
    if ($('#checkout-main').data('editshippingfromreview')) {
        $('button.nb-button.submit-shipping').addClass('from-order-review')
            .html($('button.submit-shipping').data('save-continue-text'));
    }
}
/**
 * Update the checkout state (single vs. multi-ship)
 * @param {Object} order - checkout model to use as basis of new truth
 */
function updateMultiShipInformation(order) {
    order.shipping.forEach(function (shipping) {
        if (shipping.selectedShippingMethod && shipping.selectedShippingMethod.ID !== 'Pickup') {
            $('.estimate-msg').text(shipping.selectedShippingMethod.description);
        }
    });
    var $checkoutMain = $('#checkout-main');
    var $checkbox = $('[name=usingMultiShipping]');
    var $submitShippingBtn = $('button.submit-shipping');
    $('.shipping-error .alert-danger').remove();
    if (order.usingMultiShipping) {
        $checkoutMain.addClass('multi-ship');
        $checkbox.prop('checked', true);
    } else {
        $checkoutMain.removeClass('multi-ship');
        $checkbox.prop('checked', null);
        $submitShippingBtn.prop('disabled', null);
    }
    $('body').trigger('shipping:updateMultiShipInformation', { order: order });
}
/**
  * Create an alert to display the error message
  * @param {Object} message - Error message to display
  */
function createErrorNotification(message) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error '
    + 'fade show" role="alert">'
    + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
    + '<span aria-hidden="true">&times;</span>'
    + '</button>' + message + '</div>';
    $('.shipping-error').append(errorHtml);
    scrollAnimate($('.shipping-error'));
}
/**
 * Handle response from the server for valid or invalid form fields.
 * @param {Object} defer - the deferred object which will resolve on success or reject.
 * @param {Object} data - the response data with the invalid form fields or
 *  valid model data.
 */
function shippingFormResponse(defer, data) {
    var isMultiShip = $('#checkout-main').hasClass('multi-ship');
    var formSelector = isMultiShip
        ? '.multi-shipping .active form'
        : '.single-shipping form';
    // highlight fields with errors
    if (data.error) {
        if (data.fieldErrors.length) {
            $('.shipping-address-block').removeClass('d-none');
            data.fieldErrors.forEach(function (error) {
                if (Object.keys(error).length) {
                    formHelpers.loadFormErrors(formSelector, error);
                }
            });
            defer.reject(data);
        }
        if (data.serverErrors && data.serverErrors.length) {
            $.each(data.serverErrors, function (index, element) {
                createErrorNotification(element);
            });
            defer.reject(data);
        }
        if (data.cartError) {
            window.location.href = data.redirectUrl;
            defer.reject();
        }
    } else {
        // Populate the Address Summary
        $('body').trigger('checkout:updateCheckoutView', {
            order: data.order,
            customer: data.customer
        });
        toggleGmpOrderSummary(data);
        checkOrderTotalCovered(data);
        $('#isOrderTotalGMPCovered').val(data.isOrderTotalGMPCovered);
        $('#isOrderFree').val(data.isOrderFree);
        $('#skipPayment').val(data.order.skipPayment);
        defer.resolve(data);
    }
}
/**
 * Clear out all the shipping form values and select the new address in the drop down
 * @param {Object} order - the order object
 */
function clearShippingForms(order) {
    order.shipping.forEach(function (shipping) {
        $('input[value=' + shipping.UUID + ']').each(function (formIndex, el) {
            var form = el.form;
            if (!form) return;
            $('input[name$=_firstName]', form).val('');
            $('input[name$=_lastName]', form).val('');
            $('input[name$=_firstNamePhonetic]', form).val('');
            $('input[name$=_lastNamePhonetic]', form).val('');
            $('input[name$=_address1]', form).val('');
            $('input[name$=_address2]', form).val('');
            $('input[name$=_address3]', form).val('');
            $('select[name$=_city],input[name$=_city]', form).val('');
            $('input[name$=_postalCode]', form).val('');
            $('select[name$=_stateCode],input[name$=_stateCode]', form).val('');
            $('select[name$=_country]', form).val('');
            $('input[name$=_phone]', form).val('');
            $('input[name$=_isGift]', form).prop('checked', false);
            $('textarea[name$=_giftMessage]', form).val('');

            $('input[name$=_isGiftWrap]', form).prop('checked', false);
            $('select[name$=_giftWrapText]', form).val('');

            $(form).find('.gift-message').addClass('d-none');
            $(form).find('.gift-wrap-message').addClass('d-none');
            $(form).attr('data-address-mode', 'new');
            var addressSelectorDropDown = $('.addressSelector option[value=new]', form);
            $(addressSelectorDropDown).prop('selected', true);
        });
    });
    $('body').trigger('shipping:clearShippingForms', { order: order });
}
/**
 * Does Ajax call to create a server-side shipment w/ pliUUID & URL
 * @param {string} url - string representation of endpoint URL
 * @param {Object} shipmentData - product line item UUID
 * @returns {Object} - promise value for async call
 */
function createNewShipment(url, shipmentData) {
    $.spinner().start();
    return $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: shipmentData
    });
}
/**
 * Does Ajax call to select shipping method
 * @param {string} url - string representation of endpoint URL
 * @param {Object} urlParams - url params
 * @param {Object} el - element that triggered this call
 */
function selectShippingMethodAjax(url, urlParams, el) {
    $.spinner().start();
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: urlParams
    })
        .done(function (data) {
            if (data.error) {
                window.location.href = data.redirectUrl;
            } else {
                $('body').trigger('checkout:updateCheckoutView',
                    {
                        order: data.order,
                        customer: data.customer,
                        options: { keepOpen: true },
                        urlParams: urlParams
                    });
                $('body').trigger('checkout:postUpdateCheckoutView',
                    {
                        el: el
                    });
                toggleGmpOrderSummary(data);
                if (data.isOrderTotalGMPCovered || data.isOrderFree) {
                    $('button.submit-shipping').text($('button.submit-shipping').attr('data-orderreview-text'));
                } else if ($('#checkout-main').data('editshippingfromreview')) {
                    $('button.nb-button.submit-shipping').addClass('from-order-review')
                        .html($('button.submit-shipping').data('save-continue-text'));
                } else {
                    $('button.submit-shipping').text($('button.submit-shipping').attr('data-payment-text'));
                }
                checkOrderTotalCovered(data);
                $('#isOrderTotalGMPCovered').val(data.isOrderTotalGMPCovered);
                $('#isOrderFree').val(data.isOrderFree);
                if (window.sitePrefs.accessPoint) {
                    accessPointHelper.methods.displayShippingMethod();
                }
                if (window.sitePrefs.bossEnabled) {
                    bossHelper.methods.displayShippingMethod();
                }
                if (window.sitePrefs.cvsPickupEnabled) {
                    cvsHelper.methods.displayShippingMethod();
                }
                if (window.sitePrefs.yamatoPickupEnabled) {
                    yamatoHelper.methods.displayShippingMethod();
                }
            }
            $.spinner().stop();
        })
        .fail(function () {
            $.spinner().stop();
        });
}
/**
 * Hide and show to appropriate elements to show the multi ship shipment cards in the enter view
 * @param {jQuery} element - The shipping content
 */
function enterMultishipView(element) {
    element.find('.btn-enter-multi-ship').removeClass('d-none');
    element.find('.view-address-block').addClass('d-none');
    element.find('.shipping-address').addClass('d-none');
    element.find('.btn-save-multi-ship.save-shipment').addClass('d-none');
    element.find('.btn-edit-multi-ship').addClass('d-none');
    element.find('.multi-ship-address-actions').addClass('d-none');
}
/**
 * Hide and show to appropriate elements to show the multi ship shipment cards in the view mode
 * @param {jQuery} element - The shipping content
 */
function viewMultishipAddress(element) {
    element.find('.view-address-block').removeClass('d-none');
    element.find('.btn-edit-multi-ship').removeClass('d-none');
    element.find('.shipping-address').addClass('d-none');
    element.find('.btn-save-multi-ship.save-shipment').addClass('d-none');
    element.find('.btn-enter-multi-ship').addClass('d-none');
    element.find('.multi-ship-address-actions').addClass('d-none');
}
/**
 * Hide and show to appropriate elements that allows the user to edit multi ship address information
 * @param {jQuery} element - The shipping content
 */
function editMultiShipAddress(element) {
    // Show
    element.find('.shipping-address').removeClass('d-none');
    element.find('.btn-save-multi-ship.save-shipment').removeClass('d-none');
    // Hide
    element.find('.view-address-block').addClass('d-none');
    element.find('.btn-enter-multi-ship').addClass('d-none');
    element.find('.btn-edit-multi-ship').addClass('d-none');
    element.find('.multi-ship-address-actions').addClass('d-none');
    $('body').trigger('shipping:editMultiShipAddress', { element: element, form: element.find('.shipping-form') });
}
/**
 * perform the proper actions once a user has clicked enter address or edit address for a shipment
 * @param {jQuery} element - The shipping content
 * @param {string} mode - the address mode
 */
function editOrEnterMultiShipInfo(element, mode) {
    var form = $(element).closest('form');
    var root = $(element).closest('.shipping-content');
    $('body').trigger('shipping:updateDataAddressMode', { form: form, mode: mode });
    editMultiShipAddress(root);
    var addressInfo = addressHelpers.methods.getAddressFieldsFromUI(form);
    var savedState = {
        UUID: $('input[name=shipmentUUID]', form).val(),
        shippingAddress: addressInfo
    };
    root.data('saved-state', JSON.stringify(savedState));
}
/**
 * Update the shipping information on the shipping page
 * @param {Object} shipMethodList - The shipping method list DOM element
 * @param {Object} baseObj - The export object
 */
function refreshShippingInfo(shipMethodList, baseObj) {
    var $shippingForm = $(shipMethodList).parents('form');
    var methodID = $(':checked', shipMethodList).val();
    var shipmentUUID = $shippingForm.find('[name=shipmentUUID]').val();
    var urlParams = addressHelpers.methods.getAddressFieldsFromUI($shippingForm);
    urlParams.shipmentUUID = shipmentUUID;
    urlParams.methodID = methodID;
    urlParams.isGift = $shippingForm.find('.gift').prop('checked');
    urlParams.giftMessage = $shippingForm.find('textarea[name$=_giftMessage]').val();

    urlParams.isGiftWrap = $shippingForm.find('.isGiftWrap').prop('checked');
    urlParams.giftWrapText = $shippingForm.find('select[name$=_giftWrapText]').val();

    var url = $(shipMethodList).data('select-shipping-method-url');
    if (baseObj.methods && baseObj.methods.selectShippingMethodAjax) {
        baseObj.methods.selectShippingMethodAjax(url, urlParams, $(shipMethodList));
    } else {
        selectShippingMethodAjax(url, urlParams, $(shipMethodList));
    }
}

/**
 * If multiCountryShipping enabled, reload shipping method list to limit
 * available shipping methods according to country exclusions
 */
(function refreshShippingMethodListForCountryExclusions() {
    var multiCountryShippingEnabled = window.sitePrefs.multiCountryShippingEnabled;
    var bossEnabled = window.sitePrefs.bossEnabled;

    // if boss enabled, it also calls updateShippingMethodList
    if (multiCountryShippingEnabled && !bossEnabled) {
        var $shippingForm = $('.shipping-form');

        // reload shipping methods for country exclusions
        updateShippingMethodList($shippingForm);
    }
}());

module.exports = {
    methods: {
        updateShippingAddressSelector: updateShippingAddressSelector,
        updateShippingAddressFormValues: updateShippingAddressFormValues,
        updateShippingMethods: updateShippingMethods,
        updateShippingSummaryInformation: updateShippingSummaryInformation,
        updatePLIShippingSummaryInformation: updatePLIShippingSummaryInformation,
        updateProductLineItemShipmentUUIDs: updateProductLineItemShipmentUUIDs,
        updateShippingInformation: updateShippingInformation,
        updateMultiShipInformation: updateMultiShipInformation,
        shippingFormResponse: shippingFormResponse,
        createNewShipment: createNewShipment,
        selectShippingMethodAjax: selectShippingMethodAjax,
        updateShippingMethodList: updateShippingMethodList,
        clearShippingForms: clearShippingForms,
        editMultiShipAddress: editMultiShipAddress,
        editOrEnterMultiShipInfo: editOrEnterMultiShipInfo,
        createErrorNotification: createErrorNotification,
        viewMultishipAddress: viewMultishipAddress
    },
    selectShippingMethod: function () {
        var baseObj = this;
        $('.shipping-method-list').on('change', function () {
            refreshShippingInfo(this, baseObj);
        });
    },
    handleStateChange: function () {
        var baseObj = this;
        if ($('#shippingState').data('shippingmethodrefresh')) {
            $('#shippingState').on('change', function () {
                var shipMethodList = $('.shipping-method-list')[0];
                if (shipMethodList) {
                    refreshShippingInfo(shipMethodList, baseObj);
                }
            });
        }
    },
    toggleMultiship: function () {
        var baseObj = this;
        $('input[name="usingMultiShipping"]').on('change', function () {
            var url = $('.multi-shipping-checkbox-block form').attr('action');
            var usingMultiShip = this.checked;
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: { usingMultiShip: usingMultiShip },
                success: function (response) {
                    if (response.error) {
                        window.location.href = response.redirectUrl;
                    } else {
                        $('body').trigger('checkout:updateCheckoutView', {
                            order: response.order,
                            customer: response.customer
                        });
                        if ($('#checkout-main').data('customer-type') === 'guest') {
                            if (baseObj.methods && baseObj.methods.clearShippingForms) {
                                baseObj.methods.clearShippingForms(response.order);
                            } else {
                                clearShippingForms(response.order);
                            }
                        } else {
                            response.order.shipping.forEach(function (shipping) {
                                $('input[value=' + shipping.UUID + ']').each(function (formIndex, el) {
                                    var form = el.form;
                                    if (!form) return;
                                    $(form).attr('data-address-mode', 'edit');
                                    var addressSelectorDropDown = $(form).find(
                                        '.addressSelector option[value="ab_'
                                        + shipping.matchingAddressId
                                        + '"]'
                                    );
                                    $(addressSelectorDropDown).prop('selected', true);
                                    $('input[name$=_isGift]', form).prop('checked', false);
                                    $('textarea[name$=_giftMessage]', form).val('');

                                    $('input[name$=_isGiftWrap]', form).prop('checked', false);
                                    $('select[name$=_giftWrapText]', form).val('');
                                    $(form).find('.gift-wrap-message').addClass('d-none');

                                    $(form).find('.gift-message').addClass('d-none');
                                });
                            });
                        }
                        if (usingMultiShip) {
                            $('body').trigger('shipping:selectMultiShipping', { data: response });
                        } else {
                            $('body').trigger('shipping:selectSingleShipping', { data: response });
                        }
                    }
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    selectSingleShipping: function () {
        $('body').on('shipping:selectSingleShipping', function () {
            $('.single-shipping .shipping-address').removeClass('d-none');
        });
    },
    selectMultiShipping: function () {
        var baseObj = this;
        $('body').on('shipping:selectMultiShipping', function (e, data) {
            $('.multi-shipping .shipping-address').addClass('d-none');
            data.data.order.shipping.forEach(function (shipping) {
                var element = $('.multi-shipping .card[data-shipment-uuid="' + shipping.UUID + '"]');
                if (shipping.shippingAddress) {
                    if (baseObj.methods && baseObj.methods.viewMultishipAddress) {
                        baseObj.methods.viewMultishipAddress($(element));
                    } else {
                        viewMultishipAddress($(element));
                    }
                } else {
                    /* eslint-disable no-lonely-if */
                    if (baseObj.methods && baseObj.methods.enterMultishipView) {
                        baseObj.methods.enterMultishipView($(element));
                    } else {
                        enterMultishipView($(element));
                    }
                    /* eslint-enable no-lonely-if */
                }
            });
        });
    },
    enterAddress: function () {
        // Disable google places for Korea site
        if ($('input[name="currentLocale"]').length > 0 && $('input[name="currentLocale"]').val() === 'ko_KR') {
            return;
        }
        var input = document.getElementById('shippingAddressOne');
        if (typeof google !== 'object' || !google.maps) { // eslint-disable-line no-undef
            return;
        }
        $('#shippingAddressOne').focus(function () {
            $(this).attr('autocomplete', 'new-password');
        });
        var countryRestrict = '';
        var shippingCountryValue = $('#shippingCountry').val();
        if (shippingCountryValue) {
            var countryValue = shippingCountryValue.toLowerCase();
            countryRestrict = [countryValue];
        } else if ($('input[name$=countryListShipping]').val()) {
            countryRestrict = $('input[name$=countryListShipping]').val().split(', ');
        }
        // Create the autocomplete object, restricting the search to geographical
        // location types.
        var options = {
            types: ['geocode'],
            componentRestrictions: { country: countryRestrict }
        };
        var autoComplete = new google.maps.places.Autocomplete(input, options); // eslint-disable-line no-undef
        var changeEvent = new Event('change');
        autoComplete.addListener('place_changed', function () {
            var place = autoComplete.getPlace();
            var placeCountry;
            if (place.address_components) {
                if (shippingCountryValue) {
                    placeCountry = shippingCountryValue;
                }
                var shippingAddressOne = document.getElementById('shippingAddressOne');
                var enteredShippingAddress = shippingAddressOne.value;
                shippingAddressOne.value = '';
                document.getElementById('shippingAddressTwo').value = '';
                var shippingAddressCity = document.getElementById('shippingAddressCity');
                for (var i = 0, len = place.address_components.length; i < len; i += 1) {
                    var component = place.address_components[i];
                    if (component.types[0] === 'street_number') {
                        shippingAddressOne.value += component.long_name + ' ';
                        shippingAddressOne.classList.add('text-entered');
                    } else if (component.types[0] === 'premise') {
                        shippingAddressOne.value = component.long_name + ' ' + shippingAddressOne.value;
                        shippingAddressOne.classList.add('text-entered');
                    } else if (component.types[0] === 'route') {
                        if (enteredShippingAddress.indexOf(component.long_name) > 0) {
                            var firstOccurence = enteredShippingAddress.indexOf(component.long_name);
                            shippingAddressOne.value = enteredShippingAddress.slice(0, firstOccurence);
                            shippingAddressOne.value += component.long_name;
                            shippingAddressOne.classList.add('text-entered');
                        } else {
                            shippingAddressOne.value += component.long_name;
                            shippingAddressOne.classList.add('text-entered');
                        }
                    } else if (component.types[0] === 'locality' || component.types[0] === 'postal_town') {
                        shippingAddressCity.value = component.long_name;
                        shippingAddressCity.classList.add('text-entered');
                        shippingAddressCity.classList.remove('is-invalid');
                    } else if (
                        component.types[0] === 'administrative_area_level_2'
                        || component.types[0] === 'administrative_area_level_1'
                    ) {
                        if (placeCountry) {
                            var shippingState = document.getElementById('shippingState');
                            if (shippingState) {
                                shippingState.value = component.short_name;
                                shippingState.classList.add('text-entered');
                                shippingState.classList.remove('is-invalid');
                                shippingState.dispatchEvent(changeEvent);
                            }
                        }
                    } else if (component.types[0] === 'postal_code') {
                        var shippingZipCode = document.getElementById('shippingZipCode');
                        shippingZipCode.value = component.long_name;
                        shippingZipCode.classList.add('text-entered');
                        shippingZipCode.classList.remove('is-invalid');
                        $(document).trigger('update:shippingMethodsList', shippingZipCode);
                        shippingZipCode.dispatchEvent(changeEvent);
                    } else if (component.types[0] === 'country') {
                        var shippingCountry = document.getElementById('shippingCountry');
                        shippingCountry.value = component.short_name;
                        shippingCountry.classList.add('text-entered');
                        // only dispatch change event if country changes when multi-country shipping enabled
                        if (window.sitePrefs && window.sitePrefs.multiCountryShippingEnabled) {
                            if (placeCountry && (placeCountry !== component.short_name)) {
                                shippingCountry.dispatchEvent(changeEvent);
                            }
                        } else {
                            shippingCountry.dispatchEvent(changeEvent);
                        }
                    } else if (component.types[0] === 'sublocality_level_2') {
                        var shippingAddressThree = document.getElementById('shippingAddressThree');
                        shippingAddressThree.value = component.short_name;
                        shippingAddressThree.classList.add('text-entered');
                    }
                }
            }
        });
        $(document).on('change, blur', '#shippingZipCode, #shippingAddressCity', function (e) {
            e.stopPropagation();
            e.preventDefault();
            var country = $('.shippingCountry').val();
            var postalCode = $('#shippingZipCode').val();
            if (postalCode == null || postalCode.length < 1) {
                return;
            }
            var isZipCodeValid = false;
            var zipCodeSelector = '.shipping-address-block .shippingZipCode';
            import(/* webpackPrefetch: true */'../zipCodes').then(function (zipCodes) {
                if (country.length > 0 && postalCode.length > 0) {
                    isZipCodeValid = utils.isZipCodeValid(postalCode, country, zipCodeSelector, zipCodes.zipCodeJSON);
                }
                if (isZipCodeValid) {
                    $(document).trigger('update:shippingMethodsList', $(e.currentTarget)[0]);
                    var getCityFromZip = $('.shipping-form').attr('data-cityfromzip');
                    if (country === 'ZA' && getCityFromZip && getCityFromZip !== 'false') {
                        import(/* webpackPrefetch: true */'../province').then(function (province) {
                            province.autofillCityState(postalCode, country, 'shippingAddressCity', 'shippingState');
                        });
                    }
                }
            });
        });
        $(document).on('change', '#shippingState', function (e) {
            var shippingStateCode = $(this).val();
            if (shippingStateCode) {
                $(document).trigger('update:shippingMethodsList', $(e.currentTarget)[0]);
            }
        });
    },
    selectSingleShipAddress: function () {
        $('.single-shipping .addressSelector').on('change', function () {
            var form = $(this).parents('form')[0];
            var selectedOption = $('option:selected', this);
            var attrs = selectedOption.data();
            var shipmentUUID = selectedOption[0].value;
            var originalUUID = $('input[name=shipmentUUID]', form).val();
            var element;

            Object.keys(attrs).forEach(function (attr) {
                element = attr === 'countryCode' ? 'country' : attr;
                if (!(element === 'country' && attrs[attr] === '')) { // If it is the country element and the incomming value is blank, don't update the val
                    $('[name$=' + element + ']', form).val(attrs[attr]);
                }
                if (element === 'stateCode') {
                    if ($('[name$=city]', form).val()) {
                        $('[name$=' + element + ']', form).val(attrs[attr]);
                    } else {
                        // set state and trigger that change handler
                        $('[name$=' + element + ']', form).val(attrs[attr]).change();
                        // set the city value first for dynamic city drop downs
                        $('[name$=city]', form).removeAttr('value');
                        $('[name$=city]', form).val(attrs.city);
                        if (!$('[name$=postalCode]', form).val()) {
                            // set the postalCode value for dynamic postalCode drop downs
                            $('[name$=postalCode]', form).removeAttr('value');
                            $('[name$=postalCode]', form).val(attrs.postalCode);
                        }
                    }
                }
            });

            if (shipmentUUID === 'new') {
                $(form).attr('data-address-mode', 'new');
                $(form).find('.shipping-address-block').removeClass('d-none');
            } else if (shipmentUUID === originalUUID) {
                $(form).attr('data-address-mode', 'shipment');
            } else if (shipmentUUID.indexOf('ab_') === 0) {
                $(form).attr('data-address-mode', 'customer');
            } else {
                $(form).attr('data-address-mode', 'edit');
            }
        });
    },
    selectMultiShipAddress: function () {
        var baseObj = this;
        $('.multi-shipping .addressSelector').on('change', function () {
            var form = $(this).closest('form');
            var selectedOption = $('option:selected', this);
            var attrs = selectedOption.data();
            var shipmentUUID = selectedOption[0].value;
            var originalUUID = $('input[name=shipmentUUID]', form).val();
            var pliUUID = $('input[name=productLineItemUUID]', form).val();
            var createNewShipmentScoped = baseObj.methods && baseObj.methods.createNewShipment
                ? baseObj.methods.createNewShipment
                : createNewShipment;
            var element;
            Object.keys(attrs).forEach(function (attr) {
                if (attr === 'isGift') {
                    $('[name$=' + attr + ']', form).prop('checked', attrs[attr]);
                    $('[name$=' + attr + ']', form).trigger('change');
                } else {
                    element = attr === 'countryCode' ? 'country' : attr;
                    $('[name$=' + element + ']', form).val(attrs[attr]);
                    if (element === 'stateCode') {
                        if ($('[name$=city]', form).val()) {
                            $('[name$=' + element + ']', form).val(attrs[attr]);
                        } else {
                            // set state and trigger that change handler
                            $('[name$=' + element + ']', form).val(attrs[attr]).change();
                            // set the city value first for dynamic city drop downs
                            $('[name$=city]', form).removeAttr('value');
                            $('[name$=city]', form).val(attrs.city);
                            if (!$('[name$=postalCode]', form).val()) {
                                // set the postalCode value for dynamic postalCode drop downs
                                $('[name$=postalCode]', form).removeAttr('value');
                                $('[name$=postalCode]', form).val(attrs.postalCode);
                            }
                        }
                    }
                }
                // Added this to ensure giftWrap and other details are set correctly
                if (attr === 'isGiftWrap') {
                    $('[name$=' + attr + ']', form).prop('checked', attrs[attr]);
                    $('[name$=' + attr + ']', form).trigger('change');
                }
            });
            if (shipmentUUID === 'new' && pliUUID) {
                var createShipmentUrl = $(this).attr('data-create-shipment-url');
                createNewShipmentScoped(createShipmentUrl, { productLineItemUUID: pliUUID })
                    .done(function (response) {
                        $.spinner().stop();
                        if (response.error) {
                            if (response.redirectUrl) {
                                window.location.href = response.redirectUrl;
                            }
                            return;
                        }
                        $('body').trigger('checkout:updateCheckoutView',
                            {
                                order: response.order,
                                customer: response.customer,
                                options: { keepOpen: true }
                            });
                        $(form).attr('data-address-mode', 'new');
                    })
                    .fail(function () {
                        $.spinner().stop();
                    });
            } else if (shipmentUUID === originalUUID) {
                $('select[name$=stateCode]', form).trigger('change');
                $(form).attr('data-address-mode', 'shipment');
            } else if (shipmentUUID.indexOf('ab_') === 0) {
                var url = $(form).attr('action');
                var serializedData = $(form).serialize();
                createNewShipmentScoped(url, serializedData)
                    .done(function (response) {
                        $.spinner().stop();
                        if (response.error) {
                            if (response.redirectUrl) {
                                window.location.href = response.redirectUrl;
                            }
                            return;
                        }
                        $('body').trigger('checkout:updateCheckoutView',
                            {
                                order: response.order,
                                customer: response.customer,
                                options: { keepOpen: true }
                            });
                        $(form).attr('data-address-mode', 'customer');
                        var $rootEl = $(form).closest('.shipping-content');
                        editMultiShipAddress($rootEl);
                    })
                    .fail(function () {
                        $.spinner().stop();
                    });
            } else {
                var updatePLIShipmentUrl = $(form).attr('action');
                var serializedAddress = $(form).serialize();
                createNewShipmentScoped(updatePLIShipmentUrl, serializedAddress)
                    .done(function (response) {
                        $.spinner().stop();
                        if (response.error) {
                            if (response.redirectUrl) {
                                window.location.href = response.redirectUrl;
                            }
                            return;
                        }
                        $('body').trigger('checkout:updateCheckoutView',
                            {
                                order: response.order,
                                customer: response.customer,
                                options: { keepOpen: true }
                            });
                        $(form).attr('data-address-mode', 'edit');
                    })
                    .fail(function () {
                        $.spinner().stop();
                    });
            }
        });
    },
    updateShippingList: function () {
        var baseObj = this;
        $(document).on('change', '.shipping-menu input[type=radio].form-check-input', function (e) {
            var $shippingMethodList = $('.shipping-method-list');
            if ($shippingMethodList.length && $shippingMethodList.is(':visible')) {
                if (baseObj.methods && baseObj.methods.updateShippingMethodList) {
                    baseObj.methods.updateShippingMethodList($(e.currentTarget.form));
                } else {
                    updateShippingMethodList($(e.currentTarget.form));
                }
            }
        });
    },
    updateDataAddressMode: function () {
        $('body').on('shipping:updateDataAddressMode', function (e, data) {
            $(data.form).attr('data-address-mode', data.mode);
        });
    },
    enterMultiShipInfo: function () {
        var baseObj = this;
        $('.btn-enter-multi-ship').on('click', function (e) {
            e.preventDefault();
            if (baseObj.methods && baseObj.methods.editOrEnterMultiShipInfo) {
                baseObj.methods.editOrEnterMultiShipInfo($(this), 'new');
            } else {
                editOrEnterMultiShipInfo($(this), 'new');
            }
        });
    },
    editMultiShipInfo: function () {
        var baseObj = this;
        $('.btn-edit-multi-ship').on('click', function (e) {
            e.preventDefault();
            if (baseObj.methods && baseObj.methods.editOrEnterMultiShipInfo) {
                baseObj.methods.editOrEnterMultiShipInfo($(this), 'edit');
            } else {
                editOrEnterMultiShipInfo($(this), 'edit');
            }
        });
    },
    saveMultiShipInfo: function () {
        var baseObj = this;
        $('.btn-save-multi-ship').on('click', function (e) {
            e.preventDefault();
            // Save address to checkoutAddressBook
            var form = $(this).closest('form');
            var $rootEl = $(this).closest('.shipping-content');
            var data = $(form).serialize();
            var url = $(form).attr('action');
            var bopisMultiShipData = window.sitePrefs.bopisEnabled ? require('./bopisMultiShip').init(form) : null;
            if (bopisMultiShipData && bopisMultiShipData.isStorePickUpMethod && !bopisMultiShipData.storeID) {
                createErrorNotification(bopisMultiShipData.errorMsg);
            } else {
                $rootEl.spinner().start();
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: data
                })
                    .done(function (response) {
                        formHelpers.clearPreviousErrors(form);
                        if (response.error) {
                            if (response.fieldErrors && response.fieldErrors.length) {
                                response.fieldErrors.forEach(function (error) {
                                    if (Object.keys(error).length) {
                                        formHelpers.loadFormErrors(form, error);
                                    }
                                });
                            } else if (response.serverErrors && response.serverErrors.length) {
                                $.each(response.serverErrors, function (index, element) {
                                    createErrorNotification(element);
                                });
                            } else if (response.redirectUrl) {
                                window.location.href = response.redirectUrl;
                            }
                        } else {
                        // Update UI from response
                            $('body').trigger('checkout:updateCheckoutView',
                                {
                                    order: response.order,
                                    customer: response.customer
                                });
                            if (baseObj.methods && baseObj.methods.viewMultishipAddress) {
                                baseObj.methods.viewMultishipAddress($rootEl);
                            } else {
                                viewMultishipAddress($rootEl);
                            }
                        }
                        if (response.order && response.order.shippable) {
                            $('button.submit-shipping').attr('disabled', null);
                        }
                        $rootEl.spinner().stop();
                    })
                    .fail(function (err) {
                        if (err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        }
                        $rootEl.spinner().stop();
                    });
            }
            return false;
        });
    },
    cancelMultiShipAddress: function () {
        var baseObj = this;
        $('.btn-cancel-multi-ship-address').on('click', function (e) {
            e.preventDefault();
            var form = $(this).closest('form');
            var $rootEl = $(this).closest('.shipping-content');
            var restoreState = $rootEl.data('saved-state');
            // Should clear out changes / restore previous state
            if (restoreState) {
                var restoreStateObj = JSON.parse(restoreState);
                var originalStateCode = restoreStateObj.shippingAddress.stateCode;
                var stateCode = $('[name$=_stateCode]', form).val();
                if (baseObj.methods && baseObj.methods.updateShippingAddressFormValues) {
                    baseObj.methods.updateShippingAddressFormValues(restoreStateObj);
                } else {
                    updateShippingAddressFormValues(restoreStateObj);
                }
                if (stateCode !== originalStateCode) {
                    $('[data-action=save]', form).trigger('click');
                } else {
                    $(form).attr('data-address-mode', 'edit');
                    if (baseObj.methods && baseObj.methods.editMultiShipAddress) {
                        baseObj.methods.editMultiShipAddress($rootEl);
                    } else {
                        editMultiShipAddress($rootEl);
                    }
                }
            }
            return false;
        });
    },
    isGift: function () {
        $('.gift').on('change', function (e) {
            e.preventDefault();
            var form = $(this).closest('form');
            var $giftMessage = $(form).find('.gift-message');
            if (this.checked) {
                $giftMessage.removeClass('d-none');
            } else {
                $giftMessage.addClass('d-none').val('');
            }
        });
    },
    isGiftWrap: function () {
        $('.isGiftWrap').on('change', function (e) {
            e.preventDefault();
            var form = $(this).closest('form');
            var $giftMessage = $(form).find('.gift-wrap-message');
            if (this.checked) {
                $giftMessage.removeClass('d-none');
            } else {
                $giftMessage.addClass('d-none').val('');
            }
        });
    },
    validateShippingBlur: validateShippingBlur
};
